import { PLATFORM } from "../constants/Constants";
import { getEnv } from './EnvHelper';


const currentPlatform = getEnv("REACT_APP_PLATFORM")?.toLowerCase();

const PlatformHelper = {
  isFahes: () => currentPlatform === PLATFORM.FAHES,
  getPlatform: () => currentPlatform,
};

export default PlatformHelper;